import React, { FunctionComponent, useMemo, useState } from "react";
import { GameInfoProps } from "../../type";
import Utils from "../../utils";
import { NotFoundView } from "../not-found";
import { Setting } from "./type";
import PiratesTreasureUtils from "./utils";

export const PiratesTreasureSettingView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const { currencies = [], payouts = {}, buyFreeSpinRate } = data as Setting;
  const [showCurrency, setShowCurrency] = useState(
    Object.values(currencies)[0]?.currency ?? ""
  );
  const currencySetting = useMemo(
    () => currencies.find((s) => s.currency === showCurrency),
    [showCurrency, currencies]
  );
  const orderedPayout = useMemo(
    () => Object.entries(payouts).sort((a, b) => b[1] - a[1]),
    [payouts]
  );
  if (!currencySetting) return <NotFoundView />;
  Utils.setCurrencySymbol(currencySetting.symbol);
  return (
    <>
      <ul className="nav nav-pills mb-3">
        {Object.values(currencies).map((c) => (
          <li key={c.currency} className="nav-item">
            <button
              className={`nav-link${
                c.currency === showCurrency ? " active" : ""
              }`}
              onClick={() => {
                setShowCurrency(c.currency);
              }}
            >
              {c.currency}
            </button>
          </li>
        ))}
      </ul>
      <div className="table-responsive">
        <table className="table table-bordered table table-striped-columns">
          <colgroup>
            <col width={"5%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"5%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"50%"} />
          </colgroup>
          <thead>
            <tr>
              <th className="align-middle">Bet Size Rate</th>
              <th className="align-middle">Min Bet</th>
              <th className="align-middle">Max Bet</th>
              <th className="align-middle">Buy Free Spin Rate</th>
              <th className="align-middle">Max Bet with Buy Free Spin</th>
              <th className="align-middle">Multiplier</th>
              <th className="align-middle">Min Payout</th>
              <th className="align-middle">Max Payout</th>
              <th className="align-middle">Max Payout with Bonus</th>
              <th className="align-middle">Chip Options</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-middle">5%</td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.minBet)}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.maxBet)}
              </td>
              <td className="align-middle">{buyFreeSpinRate}x</td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.maxBet * buyFreeSpinRate)}
              </td>
              <td>
                {orderedPayout.map(([symbol, payout]) => (
                  <div key={symbol} className="row">
                    <div className="col">
                      <div className="symbol">
                        {PiratesTreasureUtils.convertSymbol(+symbol)}
                      </div>
                    </div>
                    <div className="col d-flex align-items-center">
                      <div>{payout}</div>
                    </div>
                  </div>
                ))}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  currencySetting.minBet *
                    0.05 *
                    Math.min(...Object.values(payouts))
                )}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  currencySetting.maxBet *
                    0.05 *
                    20 * // reel 4 * 5
                    Math.max(...Object.values(payouts))
                )}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  PiratesTreasureUtils.maxPayoutFormular(currencySetting.maxBet)
                )}
              </td>
              <td className="align-middle">
                {currencySetting.chipOptions
                  .map((c) => Utils.asCurrency(c))
                  .join(", ")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
